import LinearGradient from 'react-native-linear-gradient';
import {Colors, Typography} from 'src/styles';
import {Text, View} from 'react-native';
import moment from 'moment/moment';
import React from 'react';
import {useStyle} from 'src/providers/style';

const InProgressCalendarItem = ({
  title,
  layout,
  start,
  end,
  apptDuration,
  staffColor,
  textColor,
  flagColor,
  appointmentChanged,
}: any) => {
  const styles = useStyle();

  return (
    <LinearGradient
      start={{x: 0.0, y: 0.0}}
      end={{x: 1.0, y: 1.0}}
      colors={Array(1)
        .fill([
          layout !== 'dayGridMonth'
            ? staffColor || Colors.PRIMARY_200
            : Colors.RAVEN_WHITE,
        ])
        .flat()}
      style={[
        ...(layout !== 'dayGridMonth'
          ? [
              styles.row,
              styles.positionAbsolute,
              styles.top0,
              styles.left0,
              styles.right0,
              styles.bottom0,
            ]
          : [styles.row, styles.flex, styles.paddingLRight]),
        ...(appointmentChanged
          ? [{borderRadius: 3, borderWidth: 4, borderColor: flagColor}]
          : []),
        styles.height,
      ]}>
      <View
        style={[
          ...(layout !== 'dayGridMonth'
            ? [
                styles.borderBottomLeftRadius,
                styles.borderTopLeftRadius,
                styles.marginSMRight,
                {borderLeftWidth: 4, right: 3},
              ]
            : [
                styles.alignSelfCenter,
                styles.dotL,
                styles.marginLLeft,
                styles.marginSMRight,
              ]),
          ...(appointmentChanged
            ? [
                {
                  backgroundColor: flagColor,
                  borderLeftColor: flagColor,
                  borderLeftWidth: 3,
                  borderTopLeftRadius: 2,
                  borderBottomLeftRadius: 2,
                },
              ]
            : [
                {
                  backgroundColor: flagColor,
                  borderLeftColor: flagColor,
                  borderLeftWidth: 5,
                  borderTopLeftRadius: 2,
                  borderBottomLeftRadius: 2,
                },
              ]),
        ]}
      />
      <View
        style={[
          styles.flex,
          styles.alignStart,
          styles.justifyCenter,
          styles.textOverflowClip,
        ]}>
        <Text
          numberOfLines={apptDuration >= 45 ? 2 : 1}
          style={[
            Typography.P3_MEDIUM,
            {
              color:
                layout !== 'dayGridMonth'
                  ? textColor || Colors.PRIMARY_600
                  : textColor === Colors.RAVEN_WHITE
                  ? Colors.RAVEN_BLACK
                  : textColor,
            },
          ]}>
          {title} {moment(start).format('LT')} - {moment(end).format('LT')}
        </Text>
      </View>
    </LinearGradient>
  );
};

export default InProgressCalendarItem;
